module.exports = __webpack_public_path__ + "assets/img/sunrise-solar.66d04a90.jpg";